<template>
  <v-card class="sf-card sf-card--interactive sf-stat"
          flat
          v-bind:to="to">
    <div class="sf-stat__label">{{ title }}</div>
    <div class="sf-stat__hint"
         v-if="subtitle">{{ subtitle }}</div>
    <slot>
      <div class="sf-stat__value">
        <span class="sf-stat__number">{{ value }}</span>
        <span class="sf-stat__total"
              v-if="totalValue != null">/ {{ totalValue }}</span>
      </div>
    </slot>
    <div class="sf-stat__link"
         v-if="to != null">
      {{ $t('open') }}
      <v-icon color="primary"
              small>ti-arrow-right</v-icon>
    </div>
  </v-card>
</template>

<script>
  export default {
    name: 'DashboardCard',
    props: {
      subtitle: String,
      title: String,
      to: Object,
      totalValue: String,
      value: String
    }
  }
</script>

<i18n>
  {
    "de": {
      "open": "Öffnen"
    },
    "en": {
      "open": "Open"
    }
  }
</i18n>
